import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Don't automatically detect session from URL
    // We'll handle it manually in ResetPasswordPage
    detectSessionInUrl: false,
    // Keep sessions persistent
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Export common database types for convenience
export type Profile = Database['public']['Tables']['profiles']['Row'];
export type ProfileInsert = Database['public']['Tables']['profiles']['Insert'];
export type ProfileUpdate = Database['public']['Tables']['profiles']['Update'];

export type Session = Database['public']['Tables']['sessions']['Row'];
export type SessionInsert = Database['public']['Tables']['sessions']['Insert'];
export type SessionUpdate = Database['public']['Tables']['sessions']['Update'];

export type Task = Database['public']['Tables']['tasks']['Row'];
export type TaskInsert = Database['public']['Tables']['tasks']['Insert'];
export type TaskUpdate = Database['public']['Tables']['tasks']['Update'];

export type ListeningSession = Database['public']['Tables']['listening_sessions']['Row'];
export type ListeningSessionInsert = Database['public']['Tables']['listening_sessions']['Insert'];
export type ListeningSessionUpdate = Database['public']['Tables']['listening_sessions']['Update'];
